export default __webpack_public_path__ + "static/desktop_sek2_KV06-d2575c2d91acd2efbceba08dbfaa713d.mp4";